import {AppState, getStore} from "../RootReducer";
import {toggleMenu, UserStatus} from "../user/UserStore";
import {connect} from "react-redux";
import React, {Fragment} from "react";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import {UserActions} from "../user/UserActions";
import SideBar from "./SideBar";
import {Routes} from "./Routes";
import CurrencySelector from "./CurrencySelector";
import IdleTimeoutView from "../login/IddleTimeoutModal";
import RequestDeniedModal from "./RequestDeniedModal";

const stateToProps  = (app : AppState)=> {
    let email = "";
    if(app.user.user && app.user.user.email) {
        email = app.user.user.email;
    }
    return (
        {
            loggedIn : app.user.status === UserStatus.LOGGED_IN,
            email : email,
            expandedMenu : app.user.expandedMenu,
            userId : app.user.user && app.user.user.id
        }
    )
}
export const LoggedInContent = (props : {loggedIn?: boolean, email?: string, expandedMenu?: boolean, userId?: number}) => (
    <Fragment>
        { props.loggedIn && (
            <Fragment>
                <div id="app-container" className={"wrapper"}>

                    <div className="navbar-custom" style={{marginTop : "-70px"}}>
                        <div className="logo-box">
                           <span className={"logo"}>
                                <span>NANO</span> {!props.expandedMenu && "Admin"}
                            </span>
                        </div>
                        <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
                            <li>
                                <button className="button-menu-mobile waves-effect waves-light" onClick={()=>toggleMenu(!getStore().getState().user.expandedMenu)}>
                                    <i className="fe-menu"></i>
                                </button>
                            </li>
                        </ul>
                        <Nav className="list-unstyled topnav-menu float-right mb-0">
                            <CurrencySelector />
                            <NavDropdown title={<span>{props.email}<i className="mdi mdi-chevron-down"></i></span>} id="basic-nav-dropdown">
                                <NavDropdown.Item href={`admin/admin-user/${props.userId}`}>
                                    <i className={"fe-settings"}></i> Settings
                                </NavDropdown.Item>
                                <NavDropdown.Item onClick={()=> new UserActions().logout()}>
                                    <i className={"fe-log-out"}></i> Logout
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>

                    </div>
                    <SideBar />
                    <div className={"content-page"}>
                        <div className={"content"}>
                            <div className={"container-fluid"}>
                                <Routes />
                            </div>
                        </div>
                    </div>
                </div>
                <IdleTimeoutView />
                <RequestDeniedModal />
            </Fragment>
        )}
    </Fragment>
);

export default connect(stateToProps)(LoggedInContent);